import { render, staticRenderFns } from "./HelpCenterSubcategoriesAndArticlesState.vue?vue&type=template&id=3b4ed334&"
import script from "./HelpCenterSubcategoriesAndArticlesState.vue?vue&type=script&lang=js&"
export * from "./HelpCenterSubcategoriesAndArticlesState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports